import React, {useEffect, useState} from 'react'
import PropTypes from "prop-types";
import {ToggleButton} from "primereact/togglebutton";
import RanglisteMarkerComponent from "../liga/RanglisteMarkerComponent";
import {InputTextarea} from "primereact/inputtextarea";
import {TabPanel, TabView} from "primereact/tabview";
import {TOURNAMENTMODUS} from "../../../constants/tournamentModus";
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import TurnierSponsorenTabPanel from "./tabs/TurnierSponsorenTabPanel";
import TurnierAdminTabPanel from "./tabs/TurnierAdminTabPanel";
import LigaAktionenComponent from "./tabs/LigaAktionenComponent";
import TournamentX01Area from "./TournamentX01Area";
import TournamentCricketArea from "./TournamentCricketArea";
import {TOURNAMENTSYSTEMS} from "../../../constants/tournamentSystems";
import TurnierQRCode from "../liga/TurnierQRCode";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import {SelectButton} from "primereact/selectbutton";
import InfoDialogEventNichtVeroeffentlichen from "../../general/InfoDialogEventNichtVeroeffentlichen";
import DHDialog from "../../general/DHDialog";
import DHDatePicker from "../../general/DHDatePicker";
import DHDateTimePicker from "../../general/DHDateTimePicker";
import DHDefaultDrawer from "../../general/DHDefaultDrawer";
import DHSelect from "../../general/DHSelect";
import EventVeranstalterAusrichterDatenComp from "./EventVeranstalterAusrichterDatenComp";
import DHTextFieldSmall from "../../general/DHTextFieldSmall";
import DHNumberTextField from "../../general/DHNumberTextField";
import DHSwitch from "../../general/DHSwitch";
import EventVeranstalterZusatzdatenComp from "./EventVeranstalterZusatzdatenComp";
import DHButtonProgress from "../../general/DHButtonProgress";
import SaveIcon from "@mui/icons-material/Save";

function LigaVerwaltenDialog({ligaId, propEventOperatorId, callBackOnClose, callBackRefresh}) {

    const darttypes = [
        {name: 'Steeldarts', code: 'STEELDARTS'},
        {name: 'E-Dart', code: 'EDART'},
        {name: 'Gemischt', code: 'GEMISCHT'},
    ];

    let [working, setWorking] = useState(false);
    let [showDartTypeNotice, setShowDartTypeNotice] = useState(false);
    let [showKennwortNotice, setShowKennwortNotice] = useState(false);
    let [showMaxAverageNotice, setShowMaxAverageNotice] = useState(false);
    let [showTeilnahmebedingungenNotice, setShowTeilnahmebedingungenNotice] = useState(false);
    let [showUrkundendruckNotice, setShowUrkundendruckNotice] = useState(false);
    let [showRanglisteNotice, setShowRanglisteNotice] = useState(false);
    let [showOnlineNotice, setShowOnlineNotice] = useState(false);

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    let [liga, setLiga] = useState(undefined);

    let [eventOperatorId, setEventOperatorId] = useState(propEventOperatorId);

    let [admins, setAdmins] = useState([]);
    let [sponsoren, setSponsoren] = useState([]);

    let [gameType, setGameType] = useState(undefined);
    let [id, setId] = useState(undefined);
    let [turnierstatus, setTurnierstatus] = useState(undefined);
    let [bezeichnung, setBezeichnung] = useState("");
    let [kennwort, setKennwort] = useState("");
    let [aufnahmenBisBullen, setAufnahmenBisBullen] = useState(undefined);
    let [tabelleSortierung, setTabelleSortierung] = useState(undefined);
    let [punkteSieg, setPunkteSieg] = useState(3);
    let [punkteUnentschieden, setPunkteUnentschieden] = useState(1);
    let [punkteVerloren, setPunkteVerloren] = useState(0);
    let [maximaleAnzahlTeilnehmer, setMaximaleAnzahlTeilnehmer] = useState(undefined);
    let [beginn, setBeginn] = useState(undefined);
    let [anmeldeende, setAnmeldeende] = useState(undefined);
    let [anzeigenAb, setAnzeigenAb] = useState(undefined);
    let [teilnahmebedingungen, setTeilnahmebedingungen] = useState(false);
    let [hinUndRueckspiel, setHinUndRueckspiel] = useState(false);
    let [doppelturnier, setDoppelturnier] = useState(false);
    let [averageObergrenze, setAverageObergrenze] = useState(undefined);
    let [urkundendruck, setUrkundendruck] = useState(false);
    let [rangliste, setRangliste] = useState(false);
    let [ranglistemarkers, setRanglistemarkers] = useState([]);
    let [beschreibung, setBeschreibung] = useState("");
    let [sets, setSets] = useState(undefined);
    // sobald der EventOperator nicht gesetzt ist, handelt es sich um keinen Veranstalter somit um einen Onlineveranstalter. Dieser kann nur Online spielen.
    let [online, setOnline] = useState(eventOperatorId === null || eventOperatorId === undefined);
    let [bezahlung, setBezahlung] = useState(false);
    let [bezahlungbetrag, setBezahlungbetrag] = useState("");
    let [mailtext, setMailtext] = useState("");
    let [homepage, setHomepage] = useState("");
    let [socialmedia, setSocialmedia] = useState("");
    let [austragungsortBezeichnung, setAustragungsortBezeichnung] = useState("");
    let [austragungsortStrasse, setAustragungsortStrasse] = useState("");
    let [austragungsortPLZ, setAustragungsortPLZ] = useState("");
    let [austragungsortOrt, setAustragungsortOrt] = useState("");
    let [austragungsortEmail, setAustragungsortEmail] = useState("");
    let [austragungsortTelefon, setAustragungsortTelefon] = useState("");
    let [publishTournament, setPublishTournament] = useState(true);
    let [scoringWithDarthelfer, setScoringWithDarthelfer] = useState(true);
    let [dartType, setDartType] = useState(darttypes[0]);
    let [registrationAllowed, setRegistrationAllowed] = useState(true);
    let [deleteUnconfirmedRegistrations, setDeleteUnconfirmedRegistrations] = useState(true);
    let [participantsMailConfirmation, setParticipantsMailConfirmation] = useState(true);

    let [bestOfLegs, setBestOfLegs] = useState(undefined);
    let [firstToLegs, setFirstToLegs] = useState(undefined);
    let [toLegs, setToLegs] = useState(undefined);
    let [modusId, setModusId] = useState(undefined);
    let [startpunkte, setStartpunkte] = useState(undefined);
    let [zufallszahlen, setZufallszahlen] = useState(null);
    let [zufallszahlenjedesleg, setZufallszahlenjedesleg] = useState(null);
    let [cutthroat, setCutthroat] = useState(null);

    let [showPublishTournamentInfo, setShowPublishTournamentInfo] = useState(false);

    useEffect(() => {
        if(!publishTournament) {
            setShowPublishTournamentInfo(true);
        }
    }, [publishTournament]);

    function istTurnierGestartet() {
        return turnierstatus === "gestartet";
    }

    function istTurnierAbgeschlossen() {
        return turnierstatus === "abgeschlossen";
    }

    function isAustragungsortPflicht() {
        // ohne Veranstalter wird immer veröffentlicht, die Austragungsortdaten sind dann aber nicht erfassbar
        return eventOperatorId !== null && eventOperatorId !== undefined && publishTournament === true;
    }

    function isLeer(wert) {
        return wert === null || wert === undefined || String(wert).trim() === "";
    }

    function ladeLiga(id) {
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.tournament + "/ladeliga/" + id,
            json => {
                let tournament = json.tournamentDto;
                setLiga(tournament);
                setId(tournament.id);
                setEventOperatorId(tournament.eventOperatorId);
                setBezeichnung(tournament.bezeichnung);
                if (tournament.beginn !== undefined && tournament.beginn !== null) {
                    setBeginn(tournament.beginn);
                }
                setGameType(tournament.gameType);
                setOnline(tournament.online);
                setTurnierstatus(tournament.tournamentstatus);
                let modusEntity = tournament.tournamentModusEntities[0];
                setSets(modusEntity.sets);
                setFirstToLegs(modusEntity.firstToLegs);
                setBestOfLegs(modusEntity.bestOfLegs);
                setToLegs(modusEntity.toLegs);
                if (tournament.gameType === "x01") {
                    setModusId(modusEntity.modusid);
                    setStartpunkte(modusEntity.startpunkte);
                } else if (tournament.gameType === "cricket") {
                    setZufallszahlen(modusEntity.zufallszahlen);
                    setZufallszahlenjedesleg(modusEntity.zufallszahlenjedesleg);
                    setCutthroat(modusEntity.cutthroat);
                }
                setBeschreibung(tournament.beschreibung);
                setKennwort(tournament.kennwort);
                setAufnahmenBisBullen(tournament.aufnahmenBisBullen !== null ? tournament.aufnahmenBisBullen : undefined);
                setMaximaleAnzahlTeilnehmer(tournament.maxAnzahlTeilnehmer);
                setAverageObergrenze(tournament.averageObergrenze);
                if (tournament.anmeldeende !== undefined && tournament.anmeldeende !== null) {
                    setAnmeldeende(tournament.anmeldeende);
                }
                if (tournament.anzeigenAb !== undefined && tournament.anzeigenAb !== null) {
                    setAnzeigenAb(tournament.anzeigenAb);
                }
                setTeilnahmebedingungen(tournament.teilnahmebedingungen);
                setHinUndRueckspiel(tournament.hinUndRueckspiel);
                setDoppelturnier(tournament.doppelturnier);
                setUrkundendruck(tournament.urkunden);
                setRangliste(tournament.rangliste);
                setRanglistemarkers(tournament.ranglistemarkers);
                let adminsNachDemLaden = [];
                for (const tmpAdmin of tournament.administratoren) {
                    adminsNachDemLaden.push(tmpAdmin.userId);
                }
                setAdmins(adminsNachDemLaden);
                let sponsorenNachDemLaden = [];
                for( const tmpSponsor of tournament.tournamentSponsorenEntities) {
                    sponsorenNachDemLaden.push(tmpSponsor.sponsorEntity.id)
                }
                setSponsoren(sponsorenNachDemLaden);

                setBezahlung(tournament.bezahlung);
                setBezahlungbetrag(tournament.bezahlungBetrag);
                setMailtext(tournament.mailtext);
                setAustragungsortBezeichnung(tournament.austragungsortBezeichnung);
                setAustragungsortStrasse(tournament.austragungsortStrasse);
                setAustragungsortPLZ(tournament.austragungsortPLZ);
                setAustragungsortOrt(tournament.austragungsortOrt);
                setAustragungsortTelefon(tournament.telefon);
                setAustragungsortEmail(tournament.email);
                setSocialmedia(tournament.socialmedia);
                setHomepage(tournament.homepage);
                setParticipantsMailConfirmation(tournament.participantsMailConfirmation);
                setRegistrationAllowed(tournament.registrationAllowed);
                setDeleteUnconfirmedRegistrations(tournament.deleteUnconfirmedRegistrations);
                setPublishTournament(tournament.publishTournament);
                setScoringWithDarthelfer(tournament.scoringWithDarthelfer);
                setTabelleSortierung(tournament.tabelleSortierung);
                setPunkteSieg(tournament.punkteSieg);
                setPunkteUnentschieden(tournament.punkteUnentschieden);
                setPunkteVerloren(tournament.punkteVerloren);
                if( tournament.dartType === null || tournament.dartType === undefined) {
                    setDartType(darttypes[0]);
                } else {
                    let tmpDartType = darttypes[0];
                    for (const tmp of darttypes) {
                        if( tmp.code === tournament.dartType) {
                            tmpDartType = tmp;
                        }
                    }
                    setDartType(tmpDartType);
                }
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
        setShowPublishTournamentInfo(false);
    }

    useEffect(() => {
        if (ligaId === null || ligaId === undefined) {
            return;
        }
        ladeLiga(ligaId);
    }, []);

    function save() {
        setErrorMessage(undefined);
        if( isAustragungsortPflicht() && (isLeer(austragungsortPLZ) || isLeer(austragungsortOrt))) {
            setErrorMessage("Sofern das Event veröffentlicht wird, müssen PLZ und Ort des Austragungsorts (Reiter Veranstalter) gefüllt sein.");
            return;
        }
        setWorking(true);
        let modusArray = [];
        if (gameType === "x01") {
            modusArray.push({
                modusTyp: TOURNAMENTMODUS.LIGA.id,
                gameType: gameType,
                modusid: modusId,
                sets: sets,
                firstToLegs: firstToLegs,
                bestOfLegs: bestOfLegs,
                toLegs: toLegs,
                startpunkte: startpunkte
            });
        } else if (gameType === "cricket") {
            modusArray.push({
                modusTyp: TOURNAMENTMODUS.LIGA.id,
                gameType: gameType,
                sets: sets,
                firstToLegs: firstToLegs,
                bestOfLegs: bestOfLegs,
                zufallszahlen: zufallszahlen,
                zufallszahlenjedesleg: zufallszahlenjedesleg,
                cutthroat: cutthroat
            });
        }

        let adminsZumSpeichern = [];
        for (const admin of admins) {
            adminsZumSpeichern.push({userId: admin});
        }

        let myPublishTournament;
        if( eventOperatorId === null || eventOperatorId === undefined) {
            // kein eventOperator, daher immer veröffentlichen
            myPublishTournament = true;
        } else {
            myPublishTournament =  publishTournament;
        }

        let data = {
            id: id, eventOperatorId: eventOperatorId, gameType: gameType,
            participantsMailConfirmation: participantsMailConfirmation,
            bezahlung: bezahlung,
            bezahlungBetrag: bezahlungbetrag,
            socialmedia: socialmedia,
            homepage: homepage,
            austragungsortBezeichnung: austragungsortBezeichnung,
            austragungsortStrasse: austragungsortStrasse,
            austragungsortPLZ: austragungsortPLZ,
            austragungsortOrt: austragungsortOrt,
            email: austragungsortEmail,
            telefon: austragungsortTelefon,
            mailtext: mailtext,
            registrationAllowed: registrationAllowed,
            deleteUnconfirmedRegistrations: deleteUnconfirmedRegistrations,
            publishTournament: myPublishTournament,
            scoringWithDarthelfer: scoringWithDarthelfer,
            dartType: dartType.code,
            online: online,
            bezeichnung: bezeichnung, beschreibung: beschreibung,
            beginn: beginn, anmeldeende: anmeldeende, anzeigenAb: anzeigenAb,
            hinUndRueckspiel: hinUndRueckspiel,
            kennwort: kennwort,
            aufnahmenBisBullen: aufnahmenBisBullen,
            turniersystem: TOURNAMENTSYSTEMS.LIGA.id,
            maximaleAnzahlTeilnehmer: maximaleAnzahlTeilnehmer,
            doppelturnier: doppelturnier, urkunden: urkundendruck,
            rangliste: rangliste, ranglistemarkers: ranglistemarkers,
            teilnahmebedingungen: teilnahmebedingungen, averageObergrenze: averageObergrenze,
            administratoren: adminsZumSpeichern,
            sponsorenZumSpeichern: sponsoren,
            tournamentModusEntities: modusArray,
            tabelleSortierung: tabelleSortierung,
            punkteSieg: punkteSieg !== null && punkteSieg !== undefined ? punkteSieg : 3,
            punkteUnentschieden: punkteUnentschieden !== null && punkteUnentschieden !== undefined ? punkteUnentschieden : 1,
            punkteVerloren: punkteVerloren !== null && punkteVerloren !== undefined ? punkteVerloren : 0,
        };
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.tournament + "/save",
            data,
            json => {
                ladeLiga(json.id);
                setInfoMessage("Turnier wurde erfolgreich gespeichert.");
                callBackRefresh();
                setWorking(false);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Speichern: " + responseNotOk.message);
                setWorking(false);
            },
            error => {
                setErrorMessage("Fehler beim Speichern: " + error.message);
                setWorking(false);
            }
        );
    }

    function eventOperatorDatenVorbelegen() {
        setErrorMessage(undefined);

        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.eventoperator + "/byId/" + eventOperatorId,
            json => {
                setHomepage(json.homepage);
                setSocialmedia(json.socialmedia);
                setAustragungsortBezeichnung(json.austragungsortBezeichnung);
                setAustragungsortStrasse(json.austragungsortStrasse);
                setAustragungsortPLZ(json.austragungsortPLZ);
                setAustragungsortOrt(json.austragungsortOrt);
                setAustragungsortEmail(json.email);
                setAustragungsortTelefon(json.telefon);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden der Veranstalterdaten: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler beim Laden der Veranstalterdaten: " + error.message);
            }
        );
    }



    function showSaveButton() {
        if (!bezeichnung || !beginn) {
            return false;
        }
        if( eventOperatorId !== null && eventOperatorId !== undefined && (publishTournament === undefined || publishTournament === null)) {
            return false;
        }
        if (gameType === "x01") {
            return sets && (firstToLegs || bestOfLegs || toLegs) && modusId && startpunkte;
        } else if (gameType === "cricket") {
            return sets && (firstToLegs || bestOfLegs) && zufallszahlen !== null && cutthroat !== null;
        } else {
            return false;
        }
    }

    const dialogFooter = (
        <div>
            <DHButtonProgress working={working} icon={<SaveIcon/>}
                              ButtonSave label="Speichern"
                              style={{marginRight: 5}}
                              disabled={!showSaveButton()} onClick={() => save()}/>
        </div>
    );

    return <DHDialog onClose={callBackOnClose} title="Liga anlegen/bearbeiten" buttons={dialogFooter} showCloseButton={true} comp={<>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)} />
        <div style={{marginBottom: 10}}>
            <DHTextFieldSmall id="id-bezeichnung" width={350} label="Bezeichnung" required={true} disabled={istTurnierAbgeschlossen()} value={bezeichnung}
                         onChange={(text) => setBezeichnung(text)} />
        </div>
        <div style={{marginBottom: 20}}>
            <DHDatePicker label="Startzeitpunkt *" disabled={istTurnierGestartet() || istTurnierAbgeschlossen()} value={beginn} changeValue={setBeginn}/>
        </div>
        <div className="grid">
            <DHDefaultDrawer onClose={() => setShowDartTypeNotice(false)} show={showDartTypeNotice} title={"Hinweis"} children={
                <div style={{padding: 20}}>
                    <div style={{marginBottom: 5}}>
                        Dart-Type wird im öffentlichen Bereich angezeigt.
                    </div>
                    <div style={{marginBottom: 5}}>
                        Bei Events von einem Veranstalter ist die richtige Auswahl wichtig, da der Scorer damit gesteuert wird ob E-Dart (Legeingabe) oder Scoring mit dem Scorer möglich ist.
                    </div>
                </div>
            }/>
            <div className="col-fixed" style={{width: 120}}>Dart-Typ:
                <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                   onClick={(e) => setShowDartTypeNotice(!showDartTypeNotice)}/>
            </div>
            <div className="col">
                <SelectButton optionLabel="name" value={dartType} options={darttypes} onChange={(e) => setDartType(e.value)}
                              disabled={istTurnierGestartet() || istTurnierAbgeschlossen()}/>
            </div>
        </div>
        <TabView style={{width: "100%", paddingTop:10, paddingLeft:10, paddingRight:10, border: "none"}}>
            <TabPanel header="Modus">
                <div style={{marginBottom: 20}}>
                    <div style={{fontWeight: "bold"}}>Punktevergabe</div>
                    <div style={{marginBottom: 10}}>
                        <DHSelect label="Tabellensortierung" width={250} id="id-tabelle-sortierung"
                                  onChange={(id) => setTabelleSortierung(id)}
                                  value={tabelleSortierung}
                                  model={[{id: "default", value: "Standard - Punkte nach Siegen"},
                                      {id: "gewonnes-leg-1-punkt", value: "Gewonnenes leg 1 Punkt"}]}/>
                    </div>
                    {tabelleSortierung === "default" && <>
                        <div style={{marginBottom: 10}}>
                            <DHNumberTextField id="id-sieg" variant="standard" value={punkteSieg} onChange={(text) => setPunkteSieg(text)} label="Sieg" width={100} min={0} max={100}/>
                        </div>
                        <div style={{marginBottom: 10}}>
                            <DHNumberTextField id="id-unentschieden" variant="standard" value={punkteUnentschieden} onChange={(text) => setPunkteUnentschieden(text)} label="Unentschieden" width={100} min={0} max={100}/>
                        </div>
                        <div style={{marginBottom: 10}}>
                            <DHNumberTextField id="id-verloren" variant="standard" value={punkteVerloren} onChange={(text) => setPunkteVerloren(text)} label="Verloren" width={100} min={0} max={100}/>
                        </div>
                    </>
                    }
                </div>
                <div className="grid" style={{textAlign: "left"}}>
                    <div className="flex align-items-center justify-content-center h-4rem"
                         style={{marginLeft: 5, marginRight: 5}}>
                    <ToggleButton style={{width: 200}} checked={gameType === 'x01'} offLabel="X01" onLabel="X01"
                                      onChange={(e) => setGameType('x01')} className={ istTurnierGestartet() || istTurnierAbgeschlossen() ? "p-disabled" : ""}/>
                        {(eventOperatorId === null || eventOperatorId === undefined) &&
                            <ToggleButton style={{width: 200}} checked={gameType === 'cricket'} offLabel="Cricket"
                                          onLabel="Cricket" onChange={(e) => setGameType('cricket')} className={ istTurnierGestartet() || istTurnierAbgeschlossen() ? "p-disabled" : ""}/>
                        }
                    </div>
                </div>
                {gameType === "x01" &&
                    <TournamentX01Area showSets={true} sets={sets} showBestOfLegs={true}
                                       showToLegs={eventOperatorId}
                                       firstToLegs={firstToLegs} bestOfLegs={bestOfLegs} toLegs={toLegs}
                                       modusId={modusId} startpunkte={startpunkte}
                                       onSetsChanged={(sets) => setSets(sets)}
                                       onFirstToLegsChanged={(firstToLegs) => setFirstToLegs(firstToLegs)}
                                       onBestOfLegsChanged={(bestOfLegs) => setBestOfLegs(bestOfLegs)}
                                       onToLegsChanged={(toLegs) => setToLegs(toLegs)}
                                       onModusIdChanged={(modusId) => setModusId(modusId)}
                                       onStartpunkteChanged={(startpunkte) => setStartpunkte(startpunkte)}
                                       aufnahmenBisBullen={aufnahmenBisBullen}
                                       onAufnahmenBisBullenChanged={(value) => setAufnahmenBisBullen(value)}
                                       bullenDisabled={istTurnierAbgeschlossen()}/>
                }
                {gameType === "cricket" &&
                    <TournamentCricketArea sets={sets} bestOfLegs={bestOfLegs} showSets={true} showBestOfLegs={true} showPflichtfelder={true}
                                           firstToLegs={firstToLegs}
                                           zufallszahlen={zufallszahlen} zufallszahlenjedesleg={zufallszahlenjedesleg} cutthroat={cutthroat}
                                           onSetsChanged={(sets) => setSets(sets)}
                                           onFirstToLegsChanged={(firstToLegs) => setFirstToLegs(firstToLegs)}
                                           onBestOfLegsChanged={(bestOfLegs) => setBestOfLegs(bestOfLegs)}
                                           onZufallszahlenChanged={(value) => setZufallszahlen(value)}
                                           onZufallszahlenjedeslegChanged={(value) => setZufallszahlenjedesleg(value)}
                                           onCutthroatChanged={(value) => setCutthroat(value)}/>
                }
            </TabPanel>
            <TabPanel header="Optionale Eingaben">
                <div className="grid">
                    <div className="col-fixed" style={{width: 200}}>Beschreibung:</div>
                </div>
                <div className="grid">
                    <div className="col" style={{width: "100%"}}>
                        <InputTextarea rows={5} cols={50} maxLength={10000} value={beschreibung}
                                       onChange={(e) => setBeschreibung(e.target.value)}/>
                    </div>
                </div>
                <hr/>
                <div className="grid">
                    <div className={"col-12 md:col-12 lg:col-12"} style={{padding: 10}}>
                        <div style={{marginBottom: 10}}>
                            <DHDefaultDrawer onClose={() => setShowKennwortNotice(false)} show={showKennwortNotice} title={"Hinweis"} children={
                                <div style={{padding: 20}}>
                                    <div style={{marginBottom: 5}}>Die Eingabe des Kennworts ist optional. Sobald ein
                                        Kennwort angegeben wird, muss der Benutzer bei
                                        der Teilnahme ein Kennwort eingeben.
                                    </div>
                                </div>
                            }/>
                            <div style={{display: "flex", alignContent: "center", alignItems: "center"}}>
                                <DHTextFieldSmall id="id-kennwort" width={200} value={kennwort} onChange={(text) => setKennwort(text)} label="Kennwort für Ligateilnahme"
                                                  disabled={istTurnierGestartet() || istTurnierAbgeschlossen()}/>
                                <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                   onClick={(e) => setShowKennwortNotice(!showKennwortNotice)}/>
                            </div>
                        </div>
                        <hr/>
                        <div style={{marginBottom: 10}}>
                            <DHNumberTextField id="id-anzahlteilnehmer" variant="standard" width={200} value={maximaleAnzahlTeilnehmer}
                                               onChange={(text) => setMaximaleAnzahlTeilnehmer(text)} label="Maximale Teilnehmerzahl"
                                               min={0} max={1024}
                                               disabled={istTurnierGestartet() || istTurnierAbgeschlossen()}/>

                        </div>
                        <div style={{marginBottom: 10}}>
                            <DHDateTimePicker label="Anmeldeende" disabled={istTurnierGestartet() || istTurnierAbgeschlossen()} value={anmeldeende} changeValue={setAnmeldeende}/>
                        </div>
                        {(eventOperatorId === null || eventOperatorId === undefined) &&
                            <div className="grid">
                                <div className="col-fixed" style={{width: 200}}>Anzeigen ab:</div>
                                <div className="col">
                                    <DHDateTimePicker disabled={istTurnierGestartet() || istTurnierAbgeschlossen()} value={anzeigenAb} changeValue={setAnzeigenAb}/>
                                </div>
                            </div>
                        }
                        {(eventOperatorId === null || eventOperatorId === undefined) &&
                            <div style={{marginBottom: 10}}>
                                <DHDefaultDrawer onClose={() => setShowMaxAverageNotice(false)} show={showMaxAverageNotice} title={"Hinweis"} children={
                                    <div style={{padding: 20}}>
                                        <div style={{marginBottom: 5}}>Als Avg. wird die 60 Tage Average des Spielers genommen.
                                        </div>
                                    </div>
                                }/>
                                <div style={{display: "flex", alignContent: "center", alignItems: "center"}}>
                                    <DHNumberTextField id="id-avgobergrenze" variant="standard" width={200} value={averageObergrenze}
                                                       onChange={(text) => setAverageObergrenze(text)} label="Average Obergrenze"
                                                       min={0} max={1024}/>
                                    <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                       onClick={(e) => setShowMaxAverageNotice(!showMaxAverageNotice)}/>
                                </div>
                            </div>
                        }
                        {(eventOperatorId === null || eventOperatorId === undefined) &&
                            <div className="grid">
                                <DHDefaultDrawer onClose={() => setShowTeilnahmebedingungenNotice(false)} show={showTeilnahmebedingungenNotice} title={"Hinweis"} children={
                                    <div style={{padding: 20}}>
                                        <div style={{marginBottom: 5}}>Sofern du Teilnahmebedingungen hinterlegt hast, muss der
                                            Ligateilnehmer diese Teilnahmebedingungen bei Ligateilnahme bestätigen.
                                        </div>
                                    </div>
                                }/>
                                <div className="col-fixed" style={{width: 200}}>Abfrage Teilnahmebedingungen:
                                    <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                       onClick={(e) => setShowTeilnahmebedingungenNotice(!showTeilnahmebedingungenNotice)}/>
                                </div>
                                <div className="col-fixed" style={{width: "100px"}}>
                                    <ToggleButton className={istTurnierGestartet() || istTurnierAbgeschlossen() ? "p-disabled" : ""}
                                                  checked={teilnahmebedingungen}
                                                  onChange={(e) => setTeilnahmebedingungen(!teilnahmebedingungen)}
                                                  onLabel="Ja" offLabel="Nein"/>
                                </div>
                            </div>
                        }
                        <div style={{marginBottom: 10}}>
                            <DHSwitch id="id-hinundrueckspiel" disabled={istTurnierGestartet() || istTurnierAbgeschlossen()} value={hinUndRueckspiel}
                                      onChange={() => setHinUndRueckspiel(!hinUndRueckspiel)} label="Hin.- und Rückspiel"/>
                        </div>
                        <div style={{marginBottom: 10}}>
                            <DHSwitch id="id-hinundrueckspiel" disabled={istTurnierGestartet() || istTurnierAbgeschlossen()} value={doppelturnier}
                                      onChange={() => setDoppelturnier(!doppelturnier)} label="Doppelliga"/>
                        </div>
                        {(eventOperatorId === null || eventOperatorId === undefined) &&
                            <div className="grid">
                                <DHDefaultDrawer onClose={() => setShowUrkundendruckNotice(false)} show={showUrkundendruckNotice} title={"Hinweis"} children={
                                    <div style={{padding: 20}}>
                                        <div style={{marginBottom: 5}}>Für abgeschlossene Ligen können Urkunden generiert
                                            werden, hierfür musst du einen 'Urkundenrohlung' mit dem Admin vereinbaren und los
                                            gehts.
                                        </div>
                                    </div>
                                }/>
                                <div className="col-fixed" style={{width: 200}}>Urkundengenerierung:
                                    <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                       onClick={(e) => setShowUrkundendruckNotice(!showUrkundendruckNotice)}/></div>
                                <div className="col-fixed" style={{width: "200px"}}>
                                    <ToggleButton
                                        className={istTurnierAbgeschlossen() ? "p-disabled" : ""}
                                        onLabel="Ja" offLabel="Nein"
                                        checked={urkundendruck}
                                        onChange={(e) => setUrkundendruck(!urkundendruck)}/>
                                </div>
                            </div>
                        }
                        {(eventOperatorId === null || eventOperatorId === undefined) && <>
                            <div className="grid">
                                <DHDefaultDrawer onClose={() => setShowRanglisteNotice(false)} show={showRanglisteNotice} title={"Hinweis"} children={
                                    <div style={{padding: 20}}>
                                        <div style={{marginBottom: 5}}>Sofern du die Liga als Rangliste markierst, wird diese
                                            bei der Ranglistenberechnung berücktsichtigt.
                                        </div>
                                        <div style={{marginBottom: 5}}>Achtung!!! Du musst Ranglistenpunkte im System
                                            definieren. Bei Fragen wende dich an den Admin.
                                        </div>
                                    </div>
                                }/>
                                <div className="col-fixed" style={{width: 200}}>Rangliste:
                                    <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                       onClick={(e) => setShowRanglisteNotice(!showRanglisteNotice)}/></div>
                                <div className="col-fixed" style={{width: "200px"}}>
                                    <ToggleButton onLabel="Ja" offLabel="Nein"
                                                  checked={rangliste}
                                                  onChange={(e) => setRangliste(!rangliste)}/>
                                </div>
                            </div>
                            {rangliste &&
                                <div className="grid">
                                    <div className="col-fixed" style={{width: 200}}>Markers:</div>
                                    <div className="col-fixed" style={{width: "200px"}}>
                                        <RanglisteMarkerComponent onValueChange={(markers) => setRanglistemarkers(markers)}
                                                                  selectedMarkers={ranglistemarkers}/>
                                    </div>
                                </div>
                            }
                        </>
                        }
                        {(eventOperatorId === null || eventOperatorId === undefined) &&
                            <div className="grid">
                                <DHDefaultDrawer onClose={() => setShowOnlineNotice(false)} show={showOnlineNotice} title={"Hinweis"} children={
                                    <div style={{padding: 20}}>
                                        <div style={{marginBottom: 5}}>
                                            Sofern du die Liga als online markierst, wird dieses online über Darthelfer gespielt. In diesem Fall müssen sich DH Benutzer an der Liga anmelden und
                                            spielen dieses
                                            Turnier gegen einen Onlinegegner.
                                        </div>
                                        <div style={{marginBottom: 5}}>
                                            Offline ist für Ligen in deinem Vereinsheim oder Zuhause. In diesem Fall kannst du die Ergebnisse von Hand in DH eintragen. Über den DH-Client kann gespielt
                                            werden, in diesem Fall werden die Ergebnisse automatisch eingetragen.
                                        </div>
                                    </div>
                                }/>
                                <div className="col-fixed" style={{width: 200}}>Online:
                                    <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                                       onClick={(e) => setShowOnlineNotice(!showOnlineNotice)}/>
                                </div>
                                <div className="col-fixed" style={{width: "200px"}}>
                                    <ToggleButton onLabel="Ja" offLabel="Nein"
                                                  checked={online}
                                                  className={eventOperatorId === null || eventOperatorId === undefined || istTurnierGestartet() || istTurnierAbgeschlossen() ? "p-disabled" : ""}
                                                  onChange={(e) => setOnline(!online)}/>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </TabPanel>
            {(eventOperatorId === null || eventOperatorId === undefined) &&
                <TabPanel header="Admins">
                    <TurnierAdminTabPanel changeAdmins={(admins) => setAdmins(admins)} onError={(message) => setErrorMessage(message)} admins={admins}/>
                </TabPanel>
            }
            {(eventOperatorId === null || eventOperatorId === undefined) &&
                <TabPanel header="Sponsoren">
                    <TurnierSponsorenTabPanel onError={(message) => setErrorMessage(message)} sponsoren={sponsoren}
                                              changeSponsoren={(sponsoren) => setSponsoren(sponsoren)}/>
                </TabPanel>
            }
            <TabPanel header="Veranstalter" disabled={eventOperatorId === null || eventOperatorId === undefined}>
                <div className="grid">
                    <div className="col-12 md:col-12 lg:col-6">
                        <EventVeranstalterZusatzdatenComp eventOperatorId={eventOperatorId}
                                                          isEventGestartet={istTurnierGestartet()}
                                                          isEventAbgeschlossen={istTurnierAbgeschlossen()}
                                                          publishTournament={publishTournament}
                                                          online={online}
                                                          scoringWithDarthelfer={scoringWithDarthelfer}
                                                          registrationAllowed={registrationAllowed}
                                                          deleteUnconfirmedRegistrations={deleteUnconfirmedRegistrations}
                                                          bezahlung={bezahlung}
                                                          bezahlungbetrag={bezahlungbetrag}
                                                          participantsMailConfirmation={participantsMailConfirmation}
                                                          mailtext={mailtext}
                                                          onPublishTournament={() => setPublishTournament(!publishTournament)}
                                                          onOnline={() => setOnline(!online)}
                                                          onScoringWithDarthelfer={() => setScoringWithDarthelfer(!scoringWithDarthelfer)}
                                                          onRegistrationAllowed={() => setRegistrationAllowed(!registrationAllowed)}
                                                          onDeleteUnconfirmedRegistrations={() => setDeleteUnconfirmedRegistrations(!deleteUnconfirmedRegistrations)}
                                                          onParticipantsMailConfirmation={() => setParticipantsMailConfirmation(!participantsMailConfirmation)}
                                                          onBezahlung={() => setBezahlung(!bezahlung)}
                                                          onBezahlungbetrag={(text) => setBezahlungbetrag(text)}
                                                          onMailtext={(text) => setMailtext(text)}
                        />
                    </div>
                    <div className="col-12 md:col-12 lg:col-6">
                        <EventVeranstalterAusrichterDatenComp
                            eventOperatorId={eventOperatorId}
                            onError={(text) => setErrorMessage(text)}
                            austragungsortTelefon={austragungsortTelefon} onChangeAustragungsortTelefon={(text) => setAustragungsortTelefon(text)}
                            austragungsortEmail={austragungsortEmail} onChangeAustragungsortEmail={(text) => setAustragungsortEmail(text)}
                            socialmedia={socialmedia} onChangeSocialmedia={(text) => setSocialmedia(text)}
                            homepage={homepage} onChangeHomepage={(text) => setHomepage(text)}
                            isEventAbgeschlossen={istTurnierAbgeschlossen()}
                            isAustragungsortPflicht={isAustragungsortPflicht()}
                            austragungsortBezeichnung={austragungsortBezeichnung} onChangeAustragungsortBezeichnung={(text) => setAustragungsortBezeichnung(text)}
                            austragungsortStrasse={austragungsortStrasse} onChangeAustragungsortStrasse={(text) => setAustragungsortStrasse(text)}
                            austragungsortPLZ={austragungsortPLZ} onChangeAustragungsortPLZ={(text) => setAustragungsortPLZ(text)}
                            austragungsortOrt={austragungsortOrt} onChangeAustragungsortOrt={(text) => setAustragungsortOrt(text)}
                        />
                    </div>
                </div>
            </TabPanel>
            <TabPanel header="Aktionen" disabled={id === undefined}>
                <LigaAktionenComponent showAsSidebar={false} proTournament={liga} onInfo={(message) => setInfoMessage(message)}
                                                               onClose={() => ""}
                                                               callBackLoadNewTournament={(newId) => {
                                                                ladeLiga(newId);
                                                                callBackRefresh();
                                                            }}
                                                               callBackOnDelete={() => {
                                                                callBackRefresh();
                                                                callBackOnClose();
                                                            }}
                                                               callBackRefresh={() => {
                                                                ladeLiga(id);
                                                                callBackRefresh();
                                                            }}
                                                               callBackCloseDialog={() => {
                                                                callBackRefresh();
                                                                callBackOnClose();
                                                            }}
                                                               onClearMessages={() => setErrorMessage(undefined)} onError={(message) => setErrorMessage(message)}/>
            </TabPanel>
            {id !== undefined &&
                <TabPanel header="QRCodes">
                    <TurnierQRCode tournamentId={id} eventOperatorId={eventOperatorId} onlineTournament={online} tournamentSystem={TOURNAMENTSYSTEMS.LIGA.id} bezeichnung={bezeichnung}/>
                </TabPanel>
            }
        </TabView>
        <div style={{marginTop:20, fontSize:10}}>TurnierId: {id}</div>
        {showPublishTournamentInfo && <InfoDialogEventNichtVeroeffentlichen onClose={() => setShowPublishTournamentInfo(false)}/>}
    </>}/>
}

LigaVerwaltenDialog.propTypes = {
    callBackOnClose: PropTypes.func.isRequired,
    callBackRefresh: PropTypes.func.isRequired,
    propsEventOperatorId: PropTypes.string,
    ligaId: PropTypes.string,
};

export default LigaVerwaltenDialog
